export const CURRENT_PAGE_TITLE = "CURRENT_PAGE_TITLE";